<template>
	<core-modal
		name="welcome-video"
		class="omapi-modal welcome-video"
		:width="888"
		@opened="setSrc"
		@before-close="removeSrc"
	>
		<modals-content>
			<iframe
				width="888"
				height="495"
				src=""
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
				ref="iframe"
			></iframe>
		</modals-content>
	</core-modal>
</template>

<script>
export default {
	props : {
		src : String,
	},
	methods : {
		setSrc () {
			this.$refs.iframe.src = this.src
		},
		removeSrc () {
			this.$refs.iframe.src = ''
		},
	},
}
</script>

<style lang="scss">
.welcome-video.v--modal-overlay {
	background: rgba(0,0,0,0.9);
	.v--modal {
		background: #000;

		.content {
			padding: 0;
			iframe {
				margin-bottom: -6px;
			}
		}
	}
}
</style>
